import { useParams } from 'react-router-dom';
import CefrDocs from './CefrDocs';

export default function Cefr() {
  const { level } = useParams<{ level: string }>();
  return <CefrDocs level={level} />;
}
